<template>
  <div class="fav-characters">
    <Header />
    <div>
      <input v-model="searchText" />
      <SearchLogo class="search"/>
    </div>
    <CategoryDisplay :categories="categories" :search-text="searchText.toLowerCase()" />
  </div>
</template>

<script>
import Header from "@/components/Header.vue"
import CategoryDisplay from "@/components/CategoryDisplay.vue"
import categories from "@/characters.ts"
import SearchLogo from "@/assets/search.svg"
export default {
  name: 'App',
  data() {
    return {categories, searchText: ''}
  },
  components: {
    Header,
    CategoryDisplay,
    SearchLogo
  }
}
</script>

<style scoped>
.fav-characters {
  font-family: "Tahoma", sans-serif;
}
.search {
  fill: white;
}
</style>
